import { COMMENTS_SERVICE } from "@/services/comments.service.js";

const state = {postCommentOutput: false, getCommentsForOccurenceOutput: {}, putCommentOutput: false, getCommentDetailsOutput: {}, deleteCommentByIdOutput: false};

const actions = {
    //Service to create comments
    postComment({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postCommentRequest');

        COMMENTS_SERVICE.postComment(input)
            .then(
                output => {
                    commit('postCommentSuccess', output);
                },
                error => {
                    commit('postCommentFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get comments for occurence
    getCommentsForOccurence({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getCommentsForOccurenceRequest');

        COMMENTS_SERVICE.getCommentsForOccurence(id)
            .then(
                output => {
                    commit('getCommentsForOccurenceSuccess', output);
                },
                error => {
                    commit('getCommentsForOccurenceFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update comments
    putComment({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putCommentRequest');

        COMMENTS_SERVICE.putComment(input)
            .then(
                output => {
                    commit('putCommentSuccess', output);
                },
                error => {
                    commit('putCommentFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get comment details
    getCommentDetails({ dispatch, commit }, uniqueIdentifier) {
        dispatch('alert/clear', null, { root: true });
        commit('getCommentDetailsRequest');

        COMMENTS_SERVICE.getCommentDetails(uniqueIdentifier)
            .then(
                output => {
                    commit('getCommentDetailsSuccess', output);
                },
                error => {
                    commit('getCommentDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete comments
    deleteCommentById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteCommentByIdRequest');

        COMMENTS_SERVICE.deleteCommentById(id)
            .then(
                output => {
                    commit('deleteCommentByIdSuccess', output);
                },
                error => {
                    commit('deleteCommentByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postComment
    postCommentRequest(state) {
        state.postCommentOutput = null;
    },
    postCommentSuccess(state, output) {
        state.postCommentOutput = true;
    },
    postCommentFailure(state) {
        state.postCommentOutput = false;
    },

    //getCommentsForOccurence
    getCommentsForOccurenceRequest(state) {
    },
    getCommentsForOccurenceSuccess(state, output) {
        state.getCommentsForOccurenceOutput = output;
    },
    getCommentsForOccurenceFailure(state) {
        state.getCommentsForOccurenceOutput = false;
    },

    //putComment
    putCommentRequest(state) {
        state.putCommentOutput = null;
    },
    putCommentSuccess(state, output) {
        state.putCommentOutput = true;
    },
    putCommentFailure(state) {
        state.putCommentOutput = false;
    },

    //getCommentDetails
    getCommentDetailsRequest(state) {
    },
    getCommentDetailsSuccess(state, output) {
        state.getCommentDetailsOutput = output;
    },
    getCommentDetailsFailure(state) {
        state.getCommentDetailsOutput = false;
    },

    //deleteCommentById
    deleteCommentByIdRequest(state) {
        state.deleteCommentByIdOutput = null;
    },
    deleteCommentByIdSuccess(state, output) {
        state.deleteCommentByIdOutput = true;
    },
    deleteCommentByIdFailure(state) {
        state.deleteCommentByIdOutput = false;
    },
};

export const comments = {
    namespaced: true,
    state,
    actions,
    mutations
};